<template>
  <div id="app">
    <!-- <div id="nav"><router-link to="/">Home</router-link> |</div> -->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
import {debounce,throttle} from '@/utils/index'
export default {

  data() {
    return {
      isMove:false,
      timer:null,
      isRouterAlive:true
    };
  },

  mounted() {
    // window.addEventListener('resize',()=>{
    //   this.calcScale()
    // })
    // this.isMove = new Date().getMinutes()
    // clearInterval(this.timer)
    // window.addEventListener('mousemove',throttle(()=>{
    //    this.isMove = new Date().getMinutes()
    // },50))
    // this.timer = setInterval(() => {
    //     if(this.isMove<new Date().getMinutes()){
    //       console.log('刷新')
    //       // window.location.reload()
    //       this.isRouterAlive = false;
    //       this.$nextTick(()=>{
    //         this.isRouterAlive = true;
    //         this.$store.commit('setView', '');
    //       });
    //     }
    //
    //   }, 1000*60*30);
  },

  methods: {
    calcScale(){
      const baseWidth = 1920;
      const baseHeight = 937;
      let windowInnerWidth = window.innerWidth;
    let windowInnerHeight = window.innerHeight;
    // let ratioW = baseWidth / windowInnerWidth;
    let ratioW = windowInnerWidth / baseWidth;
    // let ratioH = baseHeight / windowInnerHeight;
    let ratioH = windowInnerHeight / baseHeight;
    console.log(windowInnerWidth, windowInnerHeight)
    document.body.style.width = baseWidth + 'px';
    document.body.style.height = baseHeight + 'px';
    document.body.style.transformOrigin = 'left top';
    document.body.style.transform = `scale(${ratioW})`;
    }
  },
};
</script>
<style lang="less">
html,body{
  margin: 0;
  padding: 0;
  // transform: scale(1,1);
  // transform-origin:left top;
}
#app {
  width: 100%;
  height: 100%;
  /*width: 3200px;*/
  /*height: 1080px;*/
  overflow: auto;
}
// 测试
.total-output {
  background: #000;
  color: #fff
  }
</style>
